import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const activityCatalogRoutes: MenuInterface[] = [
    {
        code: 'Catalog',
        route: [
            {
                content: '$type/settings/catalog/list',
                focus: 'empty',
            }, {
                primaryRoute: 'content',
                queryParams: {closeButton: '1'}
            }
        ],
    },
];
